// extracted by mini-css-extract-plugin
export default {"horizontal":"Divider_horizontal__ZSdRs","vertical":"Divider_vertical__6yDtX"};